import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineBooksIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m22.47 18.82-1-3.86-3.15-11.59a1.0003 1.0003 0 0 0-1.22-.71l-3.87 1a1.0007 1.0007 0 0 0-.73-.33h-10a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a.9997.9997 0 0 0 1-1v-8l2.2 8.22a1 1 0 0 0 1 .74c.0864.0099.1736.0099.26 0L21.79 20a.999.999 0 0 0 .61-.47 1.0502 1.0502 0 0 0 .07-.71Zm-16 .55h-3v-2h3v2Zm0-4h-3v-6h3v6Zm0-8h-3v-2h3v2Zm5 12h-3v-2h3v2Zm0-4h-3v-6h3v6Zm0-8h-3v-2h3v2Zm2.25-1.74 2.9-.78.52 1.93-2.9.78-.52-1.93Zm2.59 9.66-1.55-5.8 2.9-.78 1.55 5.8-2.9.78Zm1 3.86-.52-1.93 2.9-.78.52 1.93-2.9.78Z"/>
  </SvgIcon>
}

export default LineBooksIcon
